import * as React from "react";
const SvgFiRrEffect = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-effect_svg__a)">
      <path
        fill="#062147"
        d="M20 16c-.016 0-.031.005-.047.005L15.697 2H23a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2h2v14.142c-1.72.447-3 1.999-3 3.858 0 2.206 1.794 4 4 4 1.2 0 2.266-.542 3-1.382.734.84 1.8 1.382 3 1.382 2.206 0 4-1.794 4-4 0-1.859-1.28-3.411-3-3.858V2h2.607l4.419 14.542C16.822 17.232 16 18.515 16 20c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4M4 22c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m8-2c0 1.103-.897 2-2 2s-2-.897-2-2 .897-2 2-2 2 .897 2 2m-3-3.858a3.98 3.98 0 0 0-2 1.24 3.98 3.98 0 0 0-2-1.24V2h4zM20 22c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-effect_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEffect;
